export default __webpack_public_path__ + "static/media/step1.2da164c4.svg";